import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface StepHeaderProps {
  title: string;
  stepNumber: number;
  description: string;
  totalSteps?: number;
}

const StepHeader: FC<StepHeaderProps> = ({ title, stepNumber, description, totalSteps = 6 }) => {
  const { t } = useTranslation('newSupplier', { keyPrefix: 'wizard' });

  return (
    <div>
      <h1 style={{ fontSize: '1.125rem', fontWeight: 500, color: 'var(--gray-700)', marginBottom: '0.25rem' }}>{title}</h1>
      <p style={{ fontSize: '0.875rem', fontWeight: 400, color: 'var(--gray-500)' }}>
        {t('stepHeader.stepOf', 'Steg {{current}} av {{total}}', { current: stepNumber, total: totalSteps })} - {description}
      </p>
    </div>
  );
};

export default StepHeader;
